import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Fade } from "react-awesome-reveal";
import "swiper/css";

import SectionTitle from "../home/SectionTitle";
import SliderLine from "../home/SliderLine";

import guidedImg from "../../img/accounts/door-guided.webp";
import activeImg from "../../img/accounts/door-active.webp";
import advancedImg from "../../img/accounts/door-advanced.webp";

const CARDS = [
  { img: guidedImg, titleKey: "accountsPage.doors.card1.title", textKey: "accountsPage.doors.card1.text" },
  { img: activeImg, titleKey: "accountsPage.doors.card2.title", textKey: "accountsPage.doors.card2.text" },
  { img: advancedImg, titleKey: "accountsPage.doors.card3.title", textKey: "accountsPage.doors.card3.text" },
];

function DoorCard({ item, t }) {
  return (
    <Fade triggerOnce direction="up" duration={600}>
      <div className="flex flex-col gap-[15px]">
        <div className="h-[156px] sm:h-[180px] lg:h-[210px] rounded-[20px] overflow-hidden">
          <img
            src={item.img}
            alt=""
            aria-hidden
            className="w-full h-full object-cover pointer-events-none select-none"
          />
        </div>
        <div className="flex flex-col gap-[15px]">
          <p className="font-['Inter'] font-bold text-[16px] leading-[1.5] text-white">
            {t(item.titleKey)}
          </p>
          <p className="font-['Inter'] font-normal text-[14px] leading-[1.5] text-white">
            {t(item.textKey)}
          </p>
        </div>
      </div>
    </Fade>
  );
}

function DifferentDoors() {
  const { t } = useTranslation();
  const swiperRef = useRef(null);
  const [current, setCurrent] = useState(0);

  return (
    <section className="mt bg-[#1c385f] py-[45px] lg:py-[75px]">
      <div className="glcontainer">
        <div className="flex flex-col lg:flex-row gap-[25px] lg:gap-[45px]">
          {/* Заголовок слева */}
          <div className="lg:w-[373px] shrink-0">
            <SectionTitle
              title1={t("accountsPage.doors.title1")}
              title2={t("accountsPage.doors.title2")}
              text={t("accountsPage.doors.subtitle")}
              align="left"
              dark
            />
          </div>

          {/* Слайдер карточек */}
          <div className="flex-1 min-w-0">
            <Swiper
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              onSlideChange={(swiper) => setCurrent(swiper.realIndex)}
              spaceBetween={16}
              slidesPerView={1}
              grabCursor
              breakpoints={{
                640: { slidesPerView: 2.15, spaceBetween: 20 },
                1024: { slidesPerView: 2, spaceBetween: 34 },
              }}
            >
              {CARDS.map((item) => (
                <SwiperSlide key={item.titleKey}>
                  <DoorCard item={item} t={t} />
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Стрелки — desktop, справа под карточками */}
            <div className="hidden lg:flex mt-[40px] items-center justify-end gap-[16px]">
              <button
                onClick={() => swiperRef.current?.slidePrev()}
                className="w-[42px] h-[42px] rounded-full border border-white flex items-center justify-center text-white hover:bg-white hover:text-[#1c385f] transition-all duration-200"
                aria-label="Previous"
              >
                <ArrowLeft strokeWidth={1.5} className="w-[20px] h-[20px]" />
              </button>
              <button
                onClick={() => swiperRef.current?.slideNext()}
                className="w-[42px] h-[42px] rounded-full border border-white flex items-center justify-center text-white hover:bg-white hover:text-[#1c385f] transition-all duration-200"
                aria-label="Next"
              >
                <ArrowRight strokeWidth={1.5} className="w-[20px] h-[20px]" />
              </button>
            </div>

            {/* Пагинация — mobile */}
            <div className="lg:hidden">
              <SliderLine
                current={current}
                total={CARDS.length}
                onPrev={() => swiperRef.current?.slidePrev()}
                onNext={() => swiperRef.current?.slideNext()}
                dark
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DifferentDoors;
